import { Injectable } from '@angular/core';
import { Intervention } from '../../../models/intervention';
import { Observable } from 'rxjs';
import { Device } from '../../../models/device';
import { ApiService } from 'src/app/core/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  getDevice(intervention: Intervention & { study_id: number }, deviceUniqueId: string): Observable<Device> {
    return this.apiService.get<Device>(`/dashboard/intervention/${intervention.id}/device/${deviceUniqueId}`);
  }

  editDeviceTag(intervention: Intervention & { study_id: number }, device: Device): Observable<Device> {
    return this.apiService.post<Device>(`/dashboard/intervention/${intervention.id}/device/${device.uuid}`, device);
  }

  getDevices(intervention: Intervention & { study_id: number }): Observable<Device[]> {
    return this.apiService.get<Device[]>(`/dashboard/intervention/${intervention.id}/devices`);
  }

  setUnusedForDevice(interventionId: number, device: Device): Observable<Device> {
    return this.apiService.post<Device>(
      `/dashboard/intervention/${interventionId}/device/${device.uuid}/unused`,
      device
    );
  }

  constructor(private apiService: ApiService) {}
}
